/** @format */

import React, { useState, useRef, useEffect } from "react";
import { Select, Badge } from "antd";
import { IUsers } from "../../AccountInfoPage.types";

interface IEditableStatusPermissionsProps {
	status: string;
	editedUsers: IUsers[];
	userId: string;
	setTheEditedUsers: (editedUsersList) => void;
	setIfUsersWereEdited: (value) => void;
	changesWereUndone: boolean;
	setUndoChanges: (value) => void;
}

const EditableStatus: React.FC<IEditableStatusPermissionsProps> = ({
	status,
	editedUsers,
	userId,
	setTheEditedUsers,
	setIfUsersWereEdited,
	changesWereUndone,
	setUndoChanges,
}) => {
	const [changedStatus, setChangedStatus] = useState<string>(status);
	const [isEditingStatus, setIsEditingStatus] = useState<boolean>(false);
	const [isDropDownVisible, setIsDropDownVisible] = useState<boolean>(false);

	const node: any = useRef();

	useEffect(() => {
		const handleOnClickEditingMode = (e) => {
			if (node.current.contains(e.target)) {
				return;
			}
			if (!isDropDownVisible) {
				setIsEditingStatus(false);
				setIfUsersWereEdited(true);
				const mappedEditedUsers = editedUsers.map((user) => {
					if (user.userId === userId) {
						user = { ...user, status: changedStatus, isEdited: true };
					}
					return user;
				});
				setTheEditedUsers(mappedEditedUsers);
			}
		};

		if (isEditingStatus) {
			document.addEventListener("mousedown", handleOnClickEditingMode);
		} else {
			document.removeEventListener("mousedown", handleOnClickEditingMode);
		}

		return () => {
			document.removeEventListener("mousedown", handleOnClickEditingMode);
		};
	}, [
		isEditingStatus,
		changedStatus,
		isDropDownVisible,
		editedUsers,
		setTheEditedUsers,
		status,
		userId,
		setIfUsersWereEdited,
	]);

	const handleOnChangeSelect = (value) => {
		setChangedStatus(value);
	};

	const handleOnDropDownVisible = () => {
		setIsDropDownVisible(true);
	};

	const handleOnSelect = () => {
		setIsDropDownVisible(false);
	};

	useEffect(() => {
		if (changesWereUndone) {
			setChangedStatus(status);
		}
	}, [changesWereUndone, status]);

	const renderStatusBadges = (status: string) => {
		if (status === "CREATED")
			return <Badge color="blue" text={changedStatus} />;
		else if (status === "ACTIVE")
			return <Badge color="lime" text={changedStatus} />;
		else if (status === "REVOKED")
			return <Badge color="gold" text={changedStatus} />;
		else if (status === "LOCKED")
			return <Badge color="purple" text={changedStatus} />;
		else if (status === "DELETED")
			return <Badge color="red" text={changedStatus} />;
	};

	const handleOnClickEditing = () => {
		setIsEditingStatus(true);
		setUndoChanges(false);
	};

	return (
		<div
			ref={node}
			onClick={handleOnClickEditing}
			className="editable-cell-value-wrapper">
			{isEditingStatus ? (
				<Select
					value={changedStatus}
					onChange={handleOnChangeSelect}
					onSelect={handleOnSelect}
					onBlur={handleOnSelect}
					onDropdownVisibleChange={handleOnDropDownVisible}>
					<Select.Option value="CREATED">CREATED</Select.Option>
					<Select.Option value="ACTIVE">ACTIVE</Select.Option>
					<Select.Option value="REVOKED">REVOKED</Select.Option>
					<Select.Option value="LOCKED">LOCKED</Select.Option>
					<Select.Option value="DELETED">DELETED</Select.Option>
				</Select>
			) : (
				renderStatusBadges(changedStatus)
			)}
		</div>
	);
};

export default EditableStatus;
